"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelectList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * LanguageSelectList.tsx
 * Author: amusiol
 * Date: 22.02.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
const Input_1 = require("./Input");
const languageList_json_1 = __importDefault(require("../translations/languageList.json"));
const LanguageSelectList = (props) => {
    const [list, setList] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const tmp = [];
        languageList_json_1.default.forEach((key) => {
            tmp.push({
                value: key.language,
                label: key.name,
            });
        });
        setList(tmp);
    }, []);
    return ((0, jsx_runtime_1.jsx)(Input_1.Input, { name: 'language_id', edit: true, label: props.label, value: props.value, dropdownOptions: list, type: 'dropdown', onChange: (e) => {
            if (props.setValue)
                props.setValue(e.value);
        }, validationControl: props.validationControl, validationErrorMessage: props.validationErrorMessage, validationRules: props.validationRules }));
};
exports.LanguageSelectList = LanguageSelectList;
